export enum DataCollectionMode {
    REGULAR = "REGULAR",
    ALL_QUESTIONS = "ALL_QUESTIONS"
}